import { i as a } from "./index-c80b6ce4.js";
import { i as d } from "./index-a22bc4f9.js";
import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 20, viewBox: "0 0 1000 200", xmlSpace: "preserve", ...t }, /* @__PURE__ */ e.createElement("desc", null, "Created with Fabric.js 5.2.4"), /* @__PURE__ */ e.createElement("defs", null), /* @__PURE__ */ e.createElement("rect", { x: 0, y: 0, width: "100%", height: "100%", fill: "transparent" }), /* @__PURE__ */ e.createElement("g", { transform: "matrix(0 0 0 0 0 0)", id: "f0ad6b64-9c6c-4690-b0c3-d69839dd831b" }), /* @__PURE__ */ e.createElement("g", { transform: "matrix(1 0 0 1 500 100)", id: "2c95c7eb-36c5-4c4f-9352-746bb4d6215d" }, /* @__PURE__ */ e.createElement("rect", { style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "currentColor",
  fillRule: "nonzero",
  opacity: 1,
  visibility: "hidden"
}, vectorEffect: "non-scaling-stroke", x: -500, y: -100, rx: 0, ry: 0, width: 1e3, height: 200 })), /* @__PURE__ */ e.createElement("g", { transform: "matrix(1.98 0 0 1.98 87.3 100)", id: "59496891-a07c-4ecb-9253-2341dd30c5c5" }, /* @__PURE__ */ e.createElement("circle", { style: {
  stroke: "rgb(0,0,0)",
  strokeWidth: 0,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "currentColor",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", cx: 0, cy: 0, r: 35 })), /* @__PURE__ */ e.createElement("g", { transform: "matrix(1.98 0 0 1.98 639.3 100)", id: "59496891-a07c-4ecb-9253-2341dd30c5c5" }, /* @__PURE__ */ e.createElement("circle", { style: {
  stroke: "rgb(0,0,0)",
  strokeWidth: 0,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "currentColor",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", cx: 0, cy: 0, r: 35 })), /* @__PURE__ */ e.createElement("g", { transform: "matrix(1.98 0 0 1.98 363.3 100)", id: "59496891-a07c-4ecb-9253-2341dd30c5c5" }, /* @__PURE__ */ e.createElement("circle", { style: {
  stroke: "rgb(0,0,0)",
  strokeWidth: 0,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "currentColor",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", cx: 0, cy: 0, r: 35 })), /* @__PURE__ */ e.createElement("g", { transform: "matrix(1.98 0 0 1.98 915.3 100)", id: "59496891-a07c-4ecb-9253-2341dd30c5c5" }, /* @__PURE__ */ e.createElement("circle", { style: {
  stroke: "rgb(0,0,0)",
  strokeWidth: 0,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "currentColor",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", cx: 0, cy: 0, r: 35 }))), o = (t) => /* @__PURE__ */ e.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M2 3H10M2 6H10M2 9H10", stroke: "#BEC5CC", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), n = (t) => /* @__PURE__ */ e.createElement("svg", { width: 964, height: 12, viewBox: "0 0 964 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("rect", { x: 964, width: 12, height: 964, transform: "rotate(90 964 0)", fill: "#425FF0" }), /* @__PURE__ */ e.createElement("path", { d: "M964 0V12L712 12C712 5.37258 717.373 0 724 0L964 0Z", fill: "#EE6873" }))), i = (t) => /* @__PURE__ */ e.createElement("svg", { width: 14, height: 8, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M13 7H1V1", stroke: "#BEC5CC", strokeLinecap: "round", strokeLinejoin: "round" })), s = (t) => /* @__PURE__ */ e.createElement("svg", { width: 12, height: 12, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-6 h-6", ...t }, /* @__PURE__ */ e.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" }));
export {
  s as Denied,
  r as DragHandle,
  d as Filled,
  o as Grip,
  n as Modal,
  a as Outlined,
  i as Submenu
};
